import {memo} from "react";

import LogoComponent from "../LogoComponent/LogoComponent";
import {
    MainHeaderFixedPlaceholderStyled,
    MainHeaderFloatStyled,
    MainHeaderItemControlPanelStyled,
    MainHeaderItemStyled,
    MainHeaderStyled,
} from './styled/MainHeaderStyled';
import {useGTMEvent} from "../../modules/GoogleTagManager/googleTagManagerHooks";

export const MainHeader = memo(({background, children, className, fixed, hideLogo}) => {
    const {handleGTMClickLogoButton} = useGTMEvent({module: 'Header'});
    return (
            <>
                {!!fixed && <MainHeaderFixedPlaceholderStyled/>}
                <MainHeaderStyled background={background} className={className} fixed={fixed}>
                    <MainHeaderFloatStyled>
                        <MainHeaderItemStyled>
                            {!hideLogo && <LogoComponent onClick={handleGTMClickLogoButton}/>}
                        </MainHeaderItemStyled>
                        <MainHeaderItemStyled>
                            <MainHeaderItemControlPanelStyled>{children}</MainHeaderItemControlPanelStyled>
                        </MainHeaderItemStyled>
                    </MainHeaderFloatStyled>
                </MainHeaderStyled>
            </>
    );
});
